import React from 'react';
import ArticleLink from '../models/ArticleLink';
import { ArticleLinkCardStyle } from '../components/ArticleLinkCard';
import Author from '../models/Author';
import TitledArticleLinkCardList from '../components/TitledArticleCardList';
import ReactHtmlParser from 'react-html-parser';
import { AuthorStructuredData } from '@gik/seo';

interface AuthorPageProps {
  author: Author;
  articleLinks: ArticleLink[];
}

export default class AuthorPage extends React.PureComponent<AuthorPageProps> {
  render() {
    return (
      <AuthorStructuredData author={this.props.author}>
        <div className="author-page">
          <div className="bs-padding-wrapper">
            <div className="bs-padding">
              {this._renderAuthorInfo()}
              {this.props.articleLinks.length > 0 && (
                <TitledArticleLinkCardList
                  title="More from this author"
                  articleLinks={this.props.articleLinks}
                  style={ArticleLinkCardStyle.small}
                  showMoreButton
                  showAds
                />
              )}
            </div>
          </div>
        </div>
      </AuthorStructuredData>
    );
  }

  private _renderAuthorInfo() {
    return (
      <div className="author-info">
        <div className="row-1">
          <div className="column-1">
            <div
              className="image"
              style={
                this.props.author.imageUrl
                  ? {
                      backgroundImage: `url("${this.props.author.imageUrl}")`,
                    }
                  : {}
              }
            ></div>
          </div>
          <div className="column-2">
            <p className="about-the-author">About the Author</p>
            <h1>{this.props.author.fullName}</h1>
            <p className="role">{this.props.author.role}</p>
          </div>
        </div>
        <div className="row-2">
          <div>{ReactHtmlParser(this.props.author.bio)}</div>
        </div>
      </div>
    );
  }
}
